import { faBars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Row } from 'reactstrap';
import Profile from '../Profile';
import { SITE_LOGO, SITE_LOGO_ALT_TEXT } from '../App/AppSettings';
 
class Header extends React.Component {

  toggleSidebar() {
    this.props.onClick();
  }
  
  render() {
    return (
        <Row className={"header-nav align-items-center flex-nowrap"}> 
          <div className="col-auto" id="sidebarBtn" data-toggle="collapse" href="#sidebarMobile" aria-expanded="false" aria-controls="sidebarMobile">
            <div className="btn btn-neutral" onClick={this.toggleSidebar.bind(this)}>
              <FontAwesomeIcon icon={faBars} />
            </div>
          </div>
          <div className="col-auto header-logo-col"><img src={ SITE_LOGO } className="header-logo" alt={ SITE_LOGO_ALT_TEXT } /></div>
          <Profile profileDisplay={true} onPageReady={this.props.onPageReady}/>
        </Row>
    );
  }
}


export default Header;